import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";
import { Modal } from "@mui/material";
import SideBar from "../components/Sidebar";
import Navbar from "../components/Navbar";

const View = styled.div`
  display: flex;
`;

const ProgressBar = styled.div`
  position: absolute;
  margin-top: 50vh;
  margin-left: 50vw;
`;

const Topics = () => {
  const location = useLocation();
  let path = location.pathname.split("/");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [data, setData] = useState([]);
  const [topics, setTopics] = useState([]);
  const id = path[2];

  const getVideos = async () => {
    setIsModalOpen(true);

    try {
      const response = await axios.post(
        `https://e-learning-ewv6.onrender.com/course`,
        {
          course_id: id,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response);
      const data = response.data;
      setIsModalOpen(false);

      setData(data);
      setTopics(data.topicsId);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVideos();
  }, []);

  return (
    <div style={{ height: "100vh", backgroundColor: "lightgray" }}>
      <Navbar />
      <Modal open={isModalOpen}>
        <ProgressBar>
          <CircularProgress style={{ color: "white" }} />
        </ProgressBar>
      </Modal>

      <View>
        <SideBar></SideBar>

        <Accordion
          className="my-2"
          style={{
            height: "calc(100vh - 70px)",
            overflow: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
          defaultActiveKey="0"
        >
          <div className="mx-auto">
            {topics.map((items, index) => {
              console.log("items", items);
              return (
                <Accordion.Item
                  eventKey={`${index}`}
                  style={{
                    padding: "5px",
                    marginTop: "20px",
                    maxWidth: "700px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: "4px",
                    boxShadow: " 5px 5px 3px 2px gray",
                  }}
                >
                  <Accordion.Header>
                    <Container
                      fluid
                      style={{
                        backgroundColor: "white",                    
                      }}
                    >
                      <Row className="d-flex">
                        <Col md={4} className="d-flex align-items-center justify-content-center">
                          <img
                            src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                            className="card-img-top"
                            alt="..."
                          />
                        </Col>
                        <Col md={8} className="d-flex flex-column justify-content-center align-items-center">
                          <Row className="">
                            <h4 class="card-title">{items.title}</h4>
                          </Row>
                          <Row>
                            <p className="">
                              We provide exicillence in undrstanding th e
                              things, You are on the temple study.
                            </p>
                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div>
                      {items.videosId.map((itemss, indexs) => {
                        return (
                          <Link to={`/videos/${itemss}`}>
                            <div>
                              <h3> Lecture {indexs + 1}</h3>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </div>
        </Accordion>
      </View>
    </div>
  );
};

export default Topics;
